import React from "react";
import "../styles/Contact.css";
import {
  FiMapPin,
  FiPhone,
  FiMail,
  FiFacebook,
  FiTwitter,
  FiInstagram,
  FiYoutube,
  FiSend
} from "react-icons/fi";

const Contact = () => {
  return (
    <div>
      <section className="contact-wrapper">
        {/* Header */}
        <div className="contact-header">
          <h2>Contact Us</h2>
          <p>We are here to listen to the people.</p>
        </div>

        <div className="formatmain">
          <div className="formatmain1">
            <h1>Get in Touch</h1>
            {/* Info Cards */}
            <div className="contact-cards">
              <div className="contact-card">
                <span className="icon-circle12">
                  <FiMapPin />
                </span>
                <div>
                  <h4>Visit Us</h4>
                  <p>எங்களைச் சந்திக்கவும்</p>
                  <span className="card-text">
                    Pin -637502
                  </span>
                </div>
              </div>

              <div className="contact-card">
                <span className="icon-circle12">
                  <FiPhone />
                </span>
                <div>
                  <h4>Call Us</h4>
                  <p>எங்களை அழைக்கவும்</p>
                  <span className="card-text">9176995369
                  </span>
                  <span className="card-text">
                    9894081162</span>
                </div>
              </div>

              <div className="contact-card">
                <span className="icon-circle12">
                  <FiMail />
                </span>
                <div>
                  <h4>Email Us</h4>
                  <p>மின்னஞ்சல் செய்யவும்</p>
                  <span className="card-text">dmk@gmail.com.</span>
                </div>
              </div>
            </div>

            {/* Social Icons */}
            <div className="social-iconsmain">
              <h1>Follow Us</h1>
              <div className="social-icons">
                <span><FiFacebook /></span>
                <span><FiTwitter /></span>
                <span><FiInstagram /></span>
                <span><FiYoutube /></span>
              </div>
            </div>
          </div>

          {/* Message Form */}
          <div className="message-section">
            <div className="message-card">
              <h3>Send us a Message</h3>
              <p>எங்களை அணுகவும்</p>

              <div className="form-group">
                <label>Name / பெயர்</label>
                <input type="text" placeholder="Your Full Name" />
              </div>

              <div className="form-group">
                <label>Mobile Number / கைபேசி எண்</label>
                <input type="text" placeholder="10-digit Mobile Number" />
              </div>

              <div className="form-group">
                <label>Message / செய்தி</label>
                <textarea placeholder="How can we help you?" />
              </div>

              <button className="submit-btn">
                Submit Message <FiSend />
              </button>
            </div>
          </div>

        </div>
      </section>
      <section className="join-wrapper">
        {/* Map Placeholder */}
        <div className="map-container">
          <FiMapPin className="map-icon" />
          <h4>Google Map Placeholder</h4>
          <p>Chennai Headquarters</p>
        </div>

        {/* CTA Section */}
        <div className="cta-container">
          <h2>"Join DMK for an Equal and Progressive Tamil Nadu"</h2>
          <p>
            சமத்துவமும் முன்னேற்றமும் கொண்ட தமிழகத்திற்காக திமுகவில் இணைவோம்
          </p>
          {/* <button className="cta-btn">Become a Member Today</button> */}
        </div>
      </section>
    </div>
  )
}

export default Contact